import { useMemo } from 'react';
import useResponsive from '@hooks/useResponsive';

const useResponsiveRows = (data: ProductBannerComponentType) => {
  const { isMobile, isTablet } = useResponsive();

  return useMemo(() => {
    if (isMobile) {
      return parseInt(data.numberOfRowsMobile || data.numberOfRowsTablet || data.numberOfRows, 10);
    }
    return parseInt(isTablet ? data.numberOfRowsTablet || data.numberOfRows : data.numberOfRows, 10);
  }, [data, isMobile, isTablet]);
};

export default useResponsiveRows;
